

import React from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import { actions } from "@gsd/redux-store-backoffice";
import ErrorPage from "../component/error-page/ErrorPage";

const {
  ui: {
    creators: { setSearchAreaCustomText }
  }
} = actions;
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setSearchAreaCustomText: () => dispatch(setSearchAreaCustomText("OPS!"))
  };
};

type ErrorPageContainerProps = ReturnType<typeof mapDispatchToProps>;

class ErrorPageContainer extends React.Component<ErrorPageContainerProps> {
  componentDidMount() {
    this.props.setSearchAreaCustomText();
  }

  render() {
    return <ErrorPage />;
  }
}

export default connect(
  null,
  mapDispatchToProps
)(ErrorPageContainer);
